// Auto-generated barrel — do not edit by hand.
// Run `yarn codegen` to refresh.
//
// Re-exports the v1 and v2 generated RTK Query slices. `export *` would
// fail for type names that appear in both schemas (mostly inline component
// schemas without v1_/v2_ prefixes), so each collision is disambiguated
// below to the v1 variant.
export * from "./generated.v1";
export * from "./generated.v2";

